module.exports = __webpack_public_path__ + "img/banner.3d9699de.png";